
import { Component, Vue, Prop } from 'vue-property-decorator'
import { BytedIconDown } from '@byte-design/vue-icons'
import NotificationListItem from './notification-list-item.vue'
import {
  NotificatinStatus,
  NotificationType,
  notificationSecondCategory,
  notificationSecondCategoryMap
} from '@/const/notification'
import { updateNotifyStatus, readAllNotify } from '@/service'

@Component({
  name: 'NotificationList',
  components: { NotificationListItem, BytedIconDown }
})
export default class NotificationList extends Vue {
  @Prop(Number) readonly unreadNum!: number

  @Prop({ type: Array, default: () => [] }) list: {
    title: string;
    content: string;
    notification_status: NotificatinStatus;
    notification_id: string; // 由于新老站内信历史兼容原因， update 用 notification_id，查详情用 notification_id_get
    notification_id_get: string;
    version: number;
    create_time: string;
    notification_type: NotificationType;
  }[]

  pickerVisible = false
  optVisible = false
  disabledReadAll = false
  isDeleting = false
  selectedNotice: any = {}
  selectedItem = notificationSecondCategory[0]
  selectedVal: NotificationType = NotificationType.ALL

  get notificationList() {
    return (this.list || []).map((i) => ({
      title: i.title,
      id: i.notification_id,
      getId: i.notification_id_get,
      read:
        i.notification_status === NotificatinStatus.READ ||
        i.notification_status === NotificatinStatus.IGNORE,
      date: i.create_time
        .split(' ')
        .slice(0, 2)
        .join(' '),
      tag: this.$t(
        notificationSecondCategoryMap?.[i.notification_type]?.label || ''
      ),
      version: i.version
    }))
  }

  get options() {
    return notificationSecondCategory.map((i) => ({
      ...i,
      label: this.$t(i.label) as string
    }))
  }

  onConfirm() {
    this.pickerVisible = !this.pickerVisible
    const findItem = this.options.find((i: any) => i.value === this.selectedVal)
    if (findItem) {
      this.selectedItem = findItem
      this.$emit('select', findItem)
    }
  }

  onInput(val: NotificationType) {
    this.selectedVal = val
  }

  onCancel() {
    this.pickerVisible = !this.pickerVisible
    this.selectedVal = this.selectedItem.value
  }

  async onDelete() {
    if (this.isDeleting) return
    this.isDeleting = true
    await this.updateStatus(NotificatinStatus.DELETE)
    this.$emit('delete')
    this.optVisible = !this.optVisible
    this.$toast({
      message: this.$t('module_notification_delete_success'),
      type: 'success'
    })
    this.isDeleting = false
  }

  onOpt(i: any) {
    this.selectedNotice = i
    this.optVisible = !this.optVisible
  }

  onItemClick(i: any) {
    this.selectedNotice = i
    if (!this.selectedNotice.read) {
      // 未读设置已读
      this.updateStatus(NotificatinStatus.READ)
      this.$emit('item-click')
    }
    this.$router.push({
      name: 'notification-detail',
      query: { version: i.version, get_id: i.getId }
    })
  }

  async updateStatus(type: NotificatinStatus) {
    try {
      await updateNotifyStatus({
        notification_id_list: [
          {
            notification_id: this.selectedNotice.id,
            version: this.selectedNotice.version
          }
        ],
        notification_status: type
      })
    } catch (error) {
      console.log(error)
    }
  }

  async onReadAll() {
    if (this.disabledReadAll) return
    try {
      this.disabledReadAll = true

      await readAllNotify()
      this.$emit('read-all')
      this.$toast({
        message: this.$t('module_notification_mark_all_read'),
        type: 'success'
      })
    } catch (error) {
      console.log(error)
    } finally {
      this.disabledReadAll = false
    }
  }
}
